import { render, staticRenderFns } from "./page.vue?vue&type=template&id=c5ba301c&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=c5ba301c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ba301c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5ba301c')) {
      api.createRecord('c5ba301c', component.options)
    } else {
      api.reload('c5ba301c', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=c5ba301c&scoped=true&", function () {
      api.rerender('c5ba301c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/secure/entries/co-pilot/routes/project/page.vue"
export default component.exports